angular.module('ikeweb.user').factory('userHashService', ['sha1', 'loginService',

    function(hash, loginService) {

        function hashWithCurrentUser(s) {
            var stringToHash = s;
            if (loginService.getLoggedInUser()) {
                stringToHash += loginService.getLoggedInUser().getSessionToken();
            }
            return hash(stringToHash);
        }

        return {
            hash: hashWithCurrentUser
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/user.hash.service.js
// module id = 603
// module chunks = 0